const utils = require('frontend-controller/lib/utils')

module.exports = {
	model: {
		content: '',
		mainAddressAttributes: {},
		secondaryAddressAttributes: {}
	},

	methods: {
		dataDealer: function(){
			var addresses = this.getResourceRegisterContent('addresses') || {};
			this.model.mainAddressAttributes 		= addresses.mainAddressAttributes || {};
			this.model.secondaryAddressAttributes 	= addresses.secondaryAddressAttributes || {};
		},

		prepare: function(storage){
			var mainAddressAttributes, secondaryAddressAttributes;
			var personRelatedAddressAttributes, postmanRelatedAddressAttributes;
			var content, elements;
			const langCode = storage.langCode || appConfig.language.default || 'de-at'
			var salutationOptions = (((this.model.fields || [])[0] || {})['category-picker-data'] || {}).options || [];
			var countryOptions = (((this.model.fields || [])[1] || {})['category-picker-data'] || {}).options || [];
			var o, option;
			var salutation;

			mainAddressAttributes 		= this.model.mainAddressAttributes || {};
			secondaryAddressAttributes 	= this.model.secondaryAddressAttributes || {};

			if(utils.collectionSize(secondaryAddressAttributes) > 0){
				if(secondaryAddressAttributes.addressType === 'media' || mainAddressAttributes.addressType !== 'media'){
					personRelatedAddressAttributes = mainAddressAttributes;
					postmanRelatedAddressAttributes = secondaryAddressAttributes;
				} else {
					personRelatedAddressAttributes = secondaryAddressAttributes;
					postmanRelatedAddressAttributes = mainAddressAttributes;
				}
			} else {
				personRelatedAddressAttributes = mainAddressAttributes;
				postmanRelatedAddressAttributes = mainAddressAttributes;
			}

			content = [];
			elements = undefined;

			// prepare human-readable salutation from categoryPicker
			salutation = personRelatedAddressAttributes.salutation;
			if(personRelatedAddressAttributes.salutation && salutationOptions.length > 0){
				for(o in salutationOptions){
					option = salutationOptions[o];
					if(option.value === personRelatedAddressAttributes.salutation){
						if(((option.lang || {})[langCode] || {}).name){
							salutation = option.lang[langCode].name;
						}
						break;
					}
				}
			}
			if(personRelatedAddressAttributes.salutation === 'm' && salutation === 'Herr') salutation = 'Herrn';

			// prepare address content
			if(postmanRelatedAddressAttributes.organisationName){
				content.push(postmanRelatedAddressAttributes.organisationName);

				elements = ['z.H.'];
				if(salutation) 									elements.push(salutation);
				if(personRelatedAddressAttributes.title) 		elements.push(personRelatedAddressAttributes.title);
				if(personRelatedAddressAttributes.firstname) 	elements.push(personRelatedAddressAttributes.firstname);
				if(personRelatedAddressAttributes.lastname) 	elements.push(personRelatedAddressAttributes.lastname);
				if(elements.length > 1) 						content.push(elements.join(' '));
			}
			else {
				if(salutation) 									content.push(salutation);

				elements = [];
				if(personRelatedAddressAttributes.title) 		elements.push(personRelatedAddressAttributes.title);
				if(personRelatedAddressAttributes.firstname) 	elements.push(personRelatedAddressAttributes.firstname);
				if(personRelatedAddressAttributes.lastname) 	elements.push(personRelatedAddressAttributes.lastname);
				if(elements.length > 0) 						content.push(elements.join(' '));
			}

			elements = [];
			if(postmanRelatedAddressAttributes.street) 		elements.push(postmanRelatedAddressAttributes.street);
			if(postmanRelatedAddressAttributes.streetNr) 	elements.push(postmanRelatedAddressAttributes.streetNr);
			if(elements.length > 0) 						content.push(elements.join(' '));

			elements = [];
			if(postmanRelatedAddressAttributes.zip) 		elements.push(postmanRelatedAddressAttributes.zip);
			if(postmanRelatedAddressAttributes.city) 		elements.push(postmanRelatedAddressAttributes.city);
			if(elements.length > 0) 						content.push(elements.join(' '));

			// prepare human-readable country from categoryPicker
			var country = postmanRelatedAddressAttributes.country;
			if(postmanRelatedAddressAttributes.country && countryOptions.length > 0){
				for(o in countryOptions){
					option = countryOptions[o];
					if(option.value === postmanRelatedAddressAttributes.country){
						if(((option.lang || {})[langCode] || {}).name){
							country = option.lang[langCode].name;
						}
						break;
					}
				}
			}
			if(country) 		content.push(String(country).toUpperCase());

			this.model.content = content.join("\n");
		}
	},

	hooks: {
		// select text after modals attach phase has been done.
		modalPostAttached: function($element, options){
			const $textarea = $element.find('textarea');
			if($textarea){
				const textarea = $textarea[0]
				textarea.focus()
				textarea.select()
			}
		},
	},

}